export default [

    {
        title: 'v8.5.5',
        subtitle: 'Sep 2020',
        side: 'right',
        icon: false,
        content:
          "Update font sizes and mobile line-heights. <br>" +
          "Add Login and Register button in the end of the contact button. <br>" +
          "Add some function to the loosely header button. <br>" +
          "IntroHeader spacing update. <br>" +
          "Update Projects status. <br>" +
          "Preperation for blog integration. <br>"
    },

    {
        title: 'v8.5.4',
        subtitle: 'August 2020',
        side: 'left',
        icon: false,
        content:
          "Fix some component layout structures. <br>" +
          "Fix some link properties on the drawer and set it also as overlay. <br>" +
          "Update code bases and maintain patches. <br>" +
          "Added more structure with html tags. <br>"
    },

    {
        title: 'v8.5.3',
        subtitle: 'August 2020',
        side: 'right',
        icon: false,
        content:
          "Code Refactoring on Home Page Components. <br>" +
          "Adding deffered intersection methods for better performance. <br>" +
          "Adding loading skeleton items as spare parts.<br>" +
          "Added Image optimization on building. <br>" +
          "Added defered lazy loading image methods with intersections.<br>" +
          "Fix some component layout structures. <br>" +
          "Fix some link properties on the drawer and set it also as overlay. <br>"
    },

    {
        title: 'v8.5.2',
        subtitle: 'August 2020',
        side: 'left',
        icon: false,
        content:
          "Optimize Page Speed by disabling pre User Auth check. <br>" +
          "Optimize Thumbnail Images for Project Previews. <br>" +
          "Optimized overall performance from 49 to 73. <br>" +
          "Disable Intro Header move animation. <br>" +
          "Fix aria attributes on images and buttons. <br>" +
          "Fix uber proportional images and logos. <br>" +
          "Adjust default text size in the middle of the nowhere. <br>" +
          "Audit and fix SEO Options. <br>" +
          "Add flexible and routed SEO rendering with fallback. <br>" +
          "Fix manifest file configuration. <br>" +
          "Fix footer heading issues. <br>" +
          "Adding rel noopener to be state of the art. <br> "
    },

    {
        title: 'v8.5.1',
        subtitle: 'Juli 2020',
        side: 'right',
        icon: false,
        content:
          "Optimized IntroHeader Component and fixed mobile view. <br>" +
          "Optimized ListPorjects Component and added animation and styling. <br>" +
          "Added Background Styling to the ListProjects Container. <br>" +
          "Added some better description to every Project that is listed. <br>" +
          "Added Sharing Thumbnails to some of the projects. <br>"
    },

    {
        title: 'v8.5.0',
        subtitle: 'Juli 2020',
        side: 'left',
        icon: false,
        content:
          "Added new Header Component with Projects overview. <br>" +
          "Added ListProjects Component with animation and Background. <br>" +
          "Added new Data Structure for Home. <br>" +
          "Added Project Overvie. <br>" +
          "Fixed about page columns and typos. <br>" +
          "Fixed Footer links. <br>"
    },

    {
        title: 'v8.4.4',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "Updates for meta og:tags and seo optimization. <br>" +
          "Adding Sitemaps for SEO performance. <br>"
    },

    {
        title: 'v8.4.3',
        subtitle: 'Juni 2020',
        side: 'left',
        icon: false,
        content:
          "Updating Links and some elements in Footer. <br>" +
          "Adding privacy and tos pages. <br>" +
          "Releasing publicy edition on main domain. <br>" +
          "Updating A'bout me page. <br>"
    },

    {
        title: 'v8.4.2',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "implement Apps Dropdown. <br>" +
          "implement User Dropdown. <br>" +
          "add mobile font size fix. <br>"
    },

    {
        title: 'v8.4.1',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "modify footer youtube link <br>" +
          "add stackoverlow link <br>"
    },

    {
        title: 'v8.4.0',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Creating new Footer Component <br>" +
          "Designing the Skills and Tools area <br>" +
          "adding better font-size skaling for mobile screens <br>" +
          "adding social media links in footer <br> " +
          "adding movement to the HeaderContainer Component <br> " +
          "adding footer to the base layout <br>"
    },

    {
        title: 'v8.3.0',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Adding og:meta tags for sharing Social Media Information. <br>" +
          "Adding endpoints for resolving images. <br>"
    },

    {
        title: 'v8.2.0',
        subtitle: 'April 2020',
        side: 'left',
        icon: false,
        content:
          "Rebuild Web Module based on the new Gkiokan.NET.v8 Framework."
    },

    { 
        headline: 'Web Module created'
    }
]
